export default __webpack_public_path__ + "static/media/logo.6ba95f54.svg";